// Бесконечная лента банков с экрана оплаты (макет 7, .banks).
// Список статичный — это подсказка «QR принимает любой банк», а не данные из API.
const BANKS = [
    { code: "K", name: "Kaspi.kz", color: "#D93A2B" },
    { code: "H", name: "Halyk", color: "#0F8C4C" },
    { code: "F", name: "ForteBank", color: "#7B1E3A" },
    { code: "J", name: "Jusan", color: "#1C2B4A" },
    { code: "Fr", name: "Freedom", color: "#0B7CC1" },
    { code: "B", name: "Bereke", color: "#0E6B57" },
    { code: "A", name: "Altyn", color: "#C79A2E" },
    { code: "E", name: "Eurasian", color: "#123C7A" },
    { code: "AC", name: "Alatau", color: "#E2A400" },
    { code: "HC", name: "Home Credit", color: "#C8102E" },
];

// Края ленты растворяются в фоне — чтобы плитки не обрывались резко.
const FADE =
    "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)";

function BanksMarquee({ label }) {
    return (
        <div className="w-full flex flex-col items-center gap-[1.2vh]">
            <span className="text-[1.3vh] font-bold uppercase tracking-[0.15em] text-[#7B8290]">
                {label}
            </span>
            <div
                className="w-full overflow-hidden"
                style={{ maskImage: FADE, WebkitMaskImage: FADE }}
            >
                {/* дорожка продублирована: сдвиг на -50% зацикливается без стыка */}
                <div
                    className="flex gap-[1.4vw] w-max"
                    style={{ animation: "bankRun 34s linear infinite" }}
                >
                    {[...BANKS, ...BANKS].map((bank, i) => (
                        <div
                            key={`${bank.name}-${i}`}
                            className="flex-none flex items-center gap-[0.8vw] bg-white rounded-full shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] pl-[0.8vw] pr-[1.6vw] py-[0.8vh] text-[1.5vh] font-bold whitespace-nowrap"
                        >
                            <span
                                className="w-[3.2vh] h-[3.2vh] rounded-[1vh] flex-none flex items-center justify-center text-white text-[1.4vh] font-extrabold"
                                style={{ background: bank.color }}
                            >
                                {bank.code}
                            </span>
                            {bank.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default BanksMarquee;
